import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";
import { ROLE } from '../../enums/roles';
import { hasRole } from '../../utils/hasRole';

import './comment-section.styles.scss';

export default function CommentSection({ comments, handlaSubmit, isLoading}) {
    const { state } = useContext(Context);

    const [newCommentText, setNewCommentText] = useState("");
    const [displaySubmit, setDisplaySubmit] = useState(false);
    const [isPrivate, setIsPrivate] = useState(0);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        setRoles(state.roles)
    }, [state.roles])

    useEffect(() => {
        const trimmedText = newCommentText.trim().replace(/\s+/g, '');
        setDisplaySubmit(trimmedText.length > 0);
    }, [newCommentText]);

    const handleSave = () => {
        handlaSubmit(newCommentText, isPrivate);
        setNewCommentText("");
    }

    return (
        <div className="form-group mb-4">
            <h6 className="translation-section-title text-muted">Comments</h6>
            <div className="comment-container">
                {comments.length > 0 && comments.map((comment, index) => (
                    <div className={`comment`} key={index}>
                        <p className="d-flex justify-content-between mb-1">
                            <span className={"comment-user text-muted"}>{comment.username}</span>
                            <span className={"comment-timestamp text-muted"}>{comment.created_at}</span>
                        </p>
                        <p className={`comment-content text-muted${comment.private === 1 ? ' private-comment' : ''}`}>{comment.text}</p>
                    </div>
                ))}
              {isLoading ? <div className="loader"></div>:null}
            </div>

            <div className="form-group mb-1">
                <textarea className={`form-control${isPrivate === 1 ? ' private-comment'  :''}`} rows="3" placeholder={"Add a comment"} onChange={(e) => setNewCommentText(e.target.value)} value={newCommentText}></textarea>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                {hasRole(roles, ROLE.ADMIN) ? <div className="d-flex">
                    <div className="m-0 cursor-pointer text-center comment-privacy-toggle">
                        <input className="d-none" type="radio" name="comment_status" id="public-comment" defaultChecked={true} onChange={() => setIsPrivate(0)} />
                        <label className="d-block cursor-pointer py-1 px-2" htmlFor="public-comment">Public</label>
                    </div>
                    <div className="m-0 cursor-pointer text-center comment-privacy-toggle">
                        <input className="d-none" type="radio" name="comment_status" id="internal-comment" onChange={() => setIsPrivate(1)} />
                        <label className="d-block cursor-pointer py-1 px-2 m-0" htmlFor="internal-comment">Internal</label>
                    </div>
                </div> : <div></div>}
                <button className={`btn btn-blue${displaySubmit ? '' : ' transparent'}`} type="button" onClick={handleSave}>Submit</button>
            </div>
        </div>
    );
}
